export const blockIconsPrivacyandsecurityAddModeratorNew = (
	<span className='material-symbols-outlined'>add_moderator</span>
);
